/* ============================================================
   MAISON CÉRAMIQUE — Main JavaScript
   ============================================================ */

// --- CART STATE ---
let cartCount = 0;

function updateCartUI() {
  document.querySelectorAll('.cart-count').forEach(el => {
    el.textContent = cartCount;
  });
}

// --- ADD TO CART ---
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.btn-add-cart').forEach(btn => {
    btn.addEventListener('click', function () {
      cartCount++;
      updateCartUI();
      const original = this.textContent;
      this.textContent = 'Added ✓';
      this.style.background = 'var(--charcoal)';
      this.style.color = 'var(--off-white)';
      setTimeout(() => {
        this.textContent = original;
        this.style.background = '';
        this.style.color = '';
      }, 1800);
    });
  });
});

function addToCart() {
  cartCount++;
  updateCartUI();
  const btn = document.querySelector('.product-actions .btn-dark');
  if (btn) {
    const original = btn.textContent;
    btn.textContent = 'Added to Cart ✓';
    setTimeout(() => { btn.textContent = original; }, 2000);
  }
}

// --- QUANTITY SELECTOR ---
function changeQty(delta) {
  const input = document.getElementById('qty');
  if (!input) return;
  let val = parseInt(input.value) + delta;
  if (val < 1) val = 1;
  input.value = val;
}

// --- GALLERY SWITCHER ---
function switchImage(thumb) {
  const mainImg = document.getElementById('main-img');
  if (mainImg) {
    mainImg.src = thumb.src;
    mainImg.alt = thumb.alt;
  }
  document.querySelectorAll('.product-gallery-thumbs img').forEach(t => t.classList.remove('active'));
  thumb.classList.add('active');
}

// --- COLLECTION FILTER ---
document.addEventListener('DOMContentLoaded', () => {
  const filterBtns = document.querySelectorAll('.filter-btn');
  const cards = document.querySelectorAll('#collection-grid .product-card');

  filterBtns.forEach(btn => {
    btn.addEventListener('click', function () {
      filterBtns.forEach(b => b.classList.remove('active'));
      this.classList.add('active');

      const filter = this.dataset.filter;
      cards.forEach(card => {
        if (filter === 'all' || card.dataset.category === filter) {
          card.style.display = '';
          card.style.opacity = '0';
          card.style.transform = 'translateY(12px)';
          requestAnimationFrame(() => {
            card.style.transition = 'opacity 0.35s ease, transform 0.35s ease';
            card.style.opacity = '1';
            card.style.transform = 'translateY(0)';
          });
        } else {
          card.style.display = 'none';
        }
      });
    });
  });
});

// --- CONTACT FORM ---
function submitContact(e) {
  e.preventDefault();
  const success = document.getElementById('form-success');
  if (success) {
    success.style.display = 'block';
    e.target.reset();
  }
}

// --- NEWSLETTER FORM ---
document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('.newsletter-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const btn = this.querySelector('button');
      const input = this.querySelector('input');
      btn.textContent = 'Subscribed ✓';
      btn.style.background = 'var(--sand)';
      input.value = '';
      setTimeout(() => {
        btn.textContent = 'Subscribe';
        btn.style.background = '';
      }, 3000);
    });
  }
});

// --- HEADER SCROLL SHADOW ---
window.addEventListener('scroll', () => {
  const header = document.querySelector('.site-header');
  if (header) {
    if (window.scrollY > 10) {
      header.style.boxShadow = '0 2px 20px rgba(26,26,26,0.06)';
    } else {
      header.style.boxShadow = 'none';
    }
  }
});

// --- SMOOTH REVEAL ON SCROLL ---
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.style.opacity = '1';
      entry.target.style.transform = 'translateY(0)';
      observer.unobserve(entry.target);
    }
  });
}, { threshold: 0.05, rootMargin: '0px 0px -20px 0px' });

document.addEventListener('DOMContentLoaded', () => {
  // Small delay so elements are in DOM before we start observing
  setTimeout(() => {
    document.querySelectorAll('.product-card, .value-item, .origin-item').forEach(el => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
      observer.observe(el);
    });
  }, 100);
});

/* ============================================================
   SEARCH DRAWER
   ============================================================ */
(function () {
  const toggle   = document.getElementById('search-toggle');
  const drawer   = document.getElementById('search-drawer');
  const overlay  = document.getElementById('search-overlay');
  const closeBtn = document.getElementById('search-close');
  const input    = document.getElementById('search-input');

  if (!toggle || !drawer) return;

  function openSearch() {
    drawer.classList.add('open');
    overlay.classList.add('active');
    toggle.setAttribute('aria-expanded', 'true');
    drawer.setAttribute('aria-hidden', 'false');
    setTimeout(() => { if (input) input.focus(); }, 350);
    document.body.style.overflow = 'hidden';
  }

  function closeSearch() {
    drawer.classList.remove('open');
    overlay.classList.remove('active');
    toggle.setAttribute('aria-expanded', 'false');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  toggle.addEventListener('click', function () {
    if (drawer.classList.contains('open')) {
      closeSearch();
    } else {
      openSearch();
    }
  });

  if (closeBtn) closeBtn.addEventListener('click', closeSearch);
  if (overlay)  overlay.addEventListener('click', closeSearch);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('open')) {
      closeSearch();
    }
  });
})();

// ============================================================
// MEGA DROPDOWN — hover on "Shop" opens full-width panel
// ============================================================
(function() {
  const wrap = document.getElementById('shop-dropdown-wrap');
  const trigger = document.getElementById('shop-trigger');
  const mega = document.getElementById('mega-dropdown');
  const overlay = document.getElementById('mega-overlay');
  if (!wrap || !mega) return;

  // Measure the bottom edge of the header (including announcement bar) for dropdown position
  function setHeaderHeight() {
    const header = document.getElementById('site-header');
    if (header) {
      const rect = header.getBoundingClientRect();
      document.documentElement.style.setProperty('--mega-top', rect.bottom + 'px');
    }
  }
  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight);
  window.addEventListener('scroll', setHeaderHeight, { passive: true });

  let closeTimer;

  function openMega() {
    clearTimeout(closeTimer);
    setHeaderHeight();
    mega.classList.add('is-open');
    overlay.classList.add('is-open');
    mega.setAttribute('aria-hidden', 'false');
  }

  function closeMega() {
    closeTimer = setTimeout(function() {
      mega.classList.remove('is-open');
      overlay.classList.remove('is-open');
      mega.setAttribute('aria-hidden', 'true');
    }, 200);
  }

  // Hover on trigger
  wrap.addEventListener('mouseenter', openMega);
  wrap.addEventListener('mouseleave', closeMega);

  // Hover on mega panel itself keeps it open
  mega.addEventListener('mouseenter', openMega);
  mega.addEventListener('mouseleave', closeMega);

  // Click overlay closes
  overlay.addEventListener('click', function() {
    mega.classList.remove('is-open');
    overlay.classList.remove('is-open');
  });

  // Escape key closes
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      mega.classList.remove('is-open');
      overlay.classList.remove('is-open');
    }
  });
})();
